import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { ScrollArea, Title } from "@mantine/core";
import { useNetwork } from "@mantine/hooks";

import { StyledWithDashboardNavbar } from "@layouts/WithDashboardNavbar/WithDashboardNavbar.styled";
import { StyledWrapper } from "@layouts/WithPatientNavbar/WithPatientNavbar.styled";

import { NetworkNotification } from "@components/NetworkNotification";

import { getAdminSettingsNavLinks } from "@data/settingsNavLinks";

import { ROLES } from "@constants/index";
import { useAuth } from "@contexts/auth";


interface WithDashboardNavbarProps {
  children: React.ReactNode;
  userRole: "staff" | "admin";
}

export const WithSettingsNavbar = ({
  children,
  userRole,
}: WithDashboardNavbarProps) => {
  const { t } = useTranslation();
  const { canAccessPath } = useAuth();

  const { online } = useNetwork();

  return (
    <>
      <NetworkNotification />
      <StyledWithDashboardNavbar
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        <div className="upper-nav">
          <Title order={2} fz={22} fw={500}>
            {t("settings")}
          </Title>
        </div>

        <ScrollArea>
          {userRole === ROLES.ADMIN && (
            <ul className="nav-links">
              {getAdminSettingsNavLinks().filter(({ value }) => canAccessPath(`/settings/admin/${value}`)).map(
                ({ id, label, value, isEnabled }) => (
                  <li
                    className={`nav-links-item ${!isEnabled ? "disabled" : ""}`}
                    key={id}>
                    <NavLink to={`/settings/admin/${value}`}>{label}</NavLink>
                  </li>
                )
              )}
            </ul>
          )}

          {/* {userRole === "staff" && (
            <ul className="nav-links">
              {getAdminSettingsNavLinks().map(
                ({ id, label, value, isEnabled }) => (
                  <li
                    className={`nav-links-item ${!isEnabled ? "disabled" : ""}`}
                    key={id}>
                    <NavLink to={`/settings/staff/${value}`}>{label}</NavLink>
                  </li>
                )
              )}
            </ul>
          )} */}
        </ScrollArea>
      </StyledWithDashboardNavbar>
      <StyledWrapper
        className={`${!online ? "show-notification" : "hide-notification"}`}>
        {children}
      </StyledWrapper>
    </>
  );
};
